import type { FetchFn, ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

type WidgetsData = Array<{ appDefinitionId: string; widgetId: string }>

export const fetchManifests = async (
	widgets: WidgetsData,
	fetchFn: FetchFn,
	clientSpecMap: ViewerClientSpecMap,
	metricsReporter: MetricsReporter,
	blocksBuilderManifestGeneratorVersion: string,
	santaDataFixerVersion: string
): Promise<Record<string, string>> => {
	const manifestsArray = await Promise.all(
		(widgets ?? []).map(async ({ appDefinitionId, widgetId }) => {
			const url = _.chain(clientSpecMap)
				.find((x) => x.appDefinitionId === appDefinitionId)
				.get(['appFields', 'platform', 'baseUrls', `${widgetId}_manifestUrl`])
				.replace('$MANIFEST_MODULE_VERSION$', blocksBuilderManifestGeneratorVersion)
				.replace('$DATA_FIXER_VERSION$', santaDataFixerVersion)
				.value()

			const manifestFetch = fetchFn(url)
				.then((resp: Response) => (resp.ok ? resp.json() : 'fallback'))
				.catch((e) => {
					metricsReporter.reportError(e)
					return 'fallback'
				})
			const schemaFetch = fetchFn(url + '&generate-schema=true')
				.then((resp: Response) => (resp.ok ? resp.json() : 'fallback'))
				.catch((e) => {
					metricsReporter.reportError(e)
					return 'fallback'
				})
			const [manifest, schema] = await Promise.all([manifestFetch, schemaFetch])
			return { id: widgetId, content: { manifest, schema } }
		})
	)

	return manifestsArray.reduce((acc: Record<string, any>, { id, content }: { id: string; content: any }) => {
		acc[id] = content
		return acc
	}, {} as Record<string, any>)
}
